import { render } from "./KioskViewPage.vue?vue&type=template&id=4451e1e0&lang=true"
import script from "./KioskViewPage.vue?vue&type=script&lang=js"
export * from "./KioskViewPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__